export const required = value => (value ? undefined : "Champ requis");
export const requiredArray = value =>
  !value?.length ? "Ajoutez au moins un élément" : undefined;

export const maxSize = max => value =>
  value.length >= max ? `Maximum ${max} characteres` : undefined;
export const composeValidators = (...validators) => value =>
  validators.reduce((error, validator) => error || validator(value), undefined);
